export default {
  plans: {
    enterprise: "enterprise",
    unlimited: "unlimited"
  }
}